import {
	DraftingCompass,
	FileImage,
	FileSpreadsheet,
	FileText,
	type LucideIcon,
} from "lucide-react";

import {
	type DocumentFileKind,
	documentFileKind,
} from "../../utils/file-types.ts";

const KIND_ICONS: Record<DocumentFileKind, LucideIcon> = {
	pdf: FileText,
	image: FileImage,
	drawing: DraftingCompass,
	text: FileText,
	sheet: FileSpreadsheet,
};

export function DocumentFileIcon({ fileName }: { fileName: string }) {
	const kind = documentFileKind(fileName);
	const Icon = KIND_ICONS[kind];
	return (
		<span className="document-file-icon" data-kind={kind} aria-hidden="true">
			<Icon />
		</span>
	);
}
